//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      context: this.item.titleFormat,
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  methods: {
    submit() {
      let emitObj = {
        submitObj: {
          title: this.context,
          questionnaireId: this.item.tenantId,
        },
        callback: () => {
          this.$emit('popup-close')
        },
      }
      this.$emit('onsubmit', emitObj)
    },
    cancle() {
      this.$emit('popup-close')
    },
  },
}
